import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="opt-in-status"
export default class extends Controller {
  static targets = ['status', 'goal', 'warning', 'submit']

  connect () {
    this.toggle()
  }

  toggle (_event) {
    const optedIn = this.statusTarget.value === 'opted_in'

    this.goalTargets.forEach(goal => {
      goal.classList.toggle('hidden', !optedIn)
    })

    this.warningTargets.forEach(warning => {
      warning.classList.toggle('hidden', optedIn)
    })

    this.submitTargets.forEach(submit => {
      if (optedIn) {
        delete submit.dataset.turboConfirm
      } else {
        submit.dataset.turboConfirm = submit.dataset.optInStatusConfirm
      }
    })
  }
}
